import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-product-gallery',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="flex flex-col gap-4">
      <!-- IMAGEN PRINCIPAL -->
      <div class="relative aspect-square w-full rounded-3xl overflow-hidden bg-gray-50 border border-gray-100 shadow-sm">
        <img 
          [src]="selectedImage" 
          [alt]="altText"
          class="w-full h-full object-cover object-center transition-all duration-300"
        />
      </div>

      <!-- CAROUSEL / GRID DE MINIATURAS -->
      <div *ngIf="images.length > 1" class="flex gap-3 overflow-x-auto pb-1">
        <button 
          *ngFor="let img of images; let i = index"
          (click)="selectedImage = img"
          [class.border-rose-500]="selectedImage === img"
          [class.border-transparent]="selectedImage !== img"
          class="relative w-20 h-20 rounded-2xl overflow-hidden border-2 bg-gray-50 flex-shrink-0 cursor-pointer transition-all hover:opacity-90"
        >
          <img [src]="img" [alt]="altText + ' ' + (i + 1)" class="w-full h-full object-cover" />
        </button>
      </div>
    </div>
  `
})
export class ProductGalleryComponent implements OnInit {
    @Input({ required: true }) images: string[] = [];
    @Input() altText: string = 'Producto';

    selectedImage: string = '';

    ngOnInit() {
        if (this.images.length > 0) {
            this.selectedImage = this.images[0];
        }
    }
}